<wr-base-dialog
  [status]="status"
  [header]="header"
  [submitResponse]="getSubmitResponse"
  [cancelResponse]="getCancelResponse"
  [disableSubmit]="isSubmitDisabled()"
  submitText="Exportieren"
  cancelText="Abbrechen">

  <div class="dialog-content">

    <div class="section">
      <span class="section-label">Titel für den Export</span>
      <nb-form-field>
        <input
          nbInput
          fullWidth
          type="text"
          [(ngModel)]="exportTitle"
          [disabled]="selectedFormat() === 'csv'"
          placeholder="Bitte Export-Titel eingeben" />
        <nb-icon nbSuffix pack="eva" icon="edit-2-outline"></nb-icon>
      </nb-form-field>
      @if (selectedFormat() === 'csv') {
        <span class="hint">Titel wird bei CSV-Export nicht verwendet.</span>
      }
    </div>

    <div class="section">
      <span class="section-label">Datensatz-Auswahl</span>
      <div class="option-group">
        <button
          nbButton
          fullWidth
          [status]="selectedCount() === 'list' ? 'primary' : 'basic'"
          [appearance]="selectedCount() === 'list' ? 'filled' : 'outline'"
          (click)="selectCount('list')"
          class="option-button">
          <nb-icon pack="eva" icon="list-outline"></nb-icon>
          Datensatz aus der Liste
        </button>
        <button
          nbButton
          fullWidth
          [status]="selectedCount() === 'all' ? 'primary' : 'basic'"
          [appearance]="selectedCount() === 'all' ? 'filled' : 'outline'"
          (click)="selectCount('all')"
          class="option-button">
          <nb-icon pack="eva" icon="home-outline"></nb-icon>
          Alle Datensätze
        </button>
      </div>
    </div>

    <div class="section">
      <span class="section-label">Export-Format</span>
      <div class="option-group">
        <button
          nbButton
          fullWidth
          [status]="selectedFormat() === 'pdf' ? 'primary' : 'basic'"
          [appearance]="selectedFormat() === 'pdf' ? 'filled' : 'outline'"
          (click)="selectFormat('pdf')"
          class="option-button">
          <nb-icon pack="eva" icon="file-text-outline"></nb-icon>
          PDF
        </button>
        <button
          nbButton
          fullWidth
          [status]="selectedFormat() === 'csv' ? 'primary' : 'basic'"
          [appearance]="selectedFormat() === 'csv' ? 'filled' : 'outline'"
          (click)="selectFormat('csv')"
          class="option-button">
          <nb-icon pack="eva" icon="grid-outline"></nb-icon>
          CSV
        </button>
      </div>
    </div>

  </div>
</wr-base-dialog>
